module.exports = __webpack_public_path__ + "static/media/france-bleu-occitanie.8ee87c94.png";